import { Route, Routes } from "react-router-dom";
import Wrap from "../../hoc/Wrap";
import { useSelector } from "react-redux";
import NewDashboardContainer from "../DashboardContainerNew/NewDashboardContainer";
import DashboardContainer from ".";
import NewDashboardContainerLatest from "../DashboardContainerLatest/NewDashboardContainer"; 
import EmployerDashboardContainer from "../EmployerDashboardContainer";
import EmployerDashboardNew from "../EmployerDashboardNew";
import AuthService from "../../services/AuthService";
import { isSet } from "../../utils/commonUtils";


const DashboardNavigate = () => {
  const isNewUI = useSelector((state) => state.common.isNewUI);
  const profileId = isSet(AuthService.getProfileId(), null);
  const profile = useSelector((state) => 
    (profileId !== null) ? state.session.profileDetails[profileId] || {} : {}
  );
  
  // Check if user is employer_admin
  const isEmployerAdmin = profile?.role === 'employer_admin';
  
  // Determine which dashboard container to use
  let DashboardPage;
  if (isEmployerAdmin) {
    // For employer_admin, use EmployerDashboardContainer
    // Note: EmployerDashboardContainer doesn't have a separate new theme version
    DashboardPage = EmployerDashboardNew;
  } else {
    // For other roles, use regular dashboard with theme selection
    DashboardPage = isNewUI ? NewDashboardContainerLatest : DashboardContainer;
  }
  
  console.log("isNewUI", isNewUI, "isEmployerAdmin", isEmployerAdmin, "DashboardPage", DashboardPage);
    
  return (
    <Wrap>  
      <Routes>
        <Route path="/" key={0}  element={<DashboardPage/>} />
      </Routes>
    </Wrap>
  );
};

export default DashboardNavigate;
